import constant from '@/constant'

// state
const _state = {
  isSlideTypeNoAudio: false,
}

// getters
const _getters = {
  getSlideTypeList: (state, getter, rootState, rootGetters) => {
    const canMergePickImageIntoPickAnswer = rootGetters['featureToggles/canMergePickImageIntoPickAnswer']
    return canMergePickImageIntoPickAnswer ? constant.allTypeSections : constant.unleashAllTypeSections
  },
}

// mutations
const mutations = {

}

// actions
const actions = {

}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
  actions,
}
